"use client";

import { useEffect, useEffectEvent } from "react";
import type { Id } from "@convex/_generated/dataModel";
import type { ProductIntent } from "@/lib/products/types";
import { addRecentlyViewed } from "@/lib/recently-viewed/storage";

interface RecentlyViewedTrackerProps {
  productId: Id<"products">;
  title: string;
  slug?: string | null;
  primaryImageUrl?: string | null;
  buyerUnitPriceCents?: number | null;
  publicIdentifier?: string | null;
  cityName?: string | null;
  stateAbbr?: string | null;
  originZip?: string | null;
  intent?: ProductIntent | null;
}

export function RecentlyViewedTracker({
  productId,
  ...rest
}: RecentlyViewedTrackerProps) {
  const recordView = useEffectEvent((viewedId: Id<"products">) => {
    addRecentlyViewed({ _id: viewedId, ...rest });
  });
  useEffect(() => {
    recordView(productId);
  }, [productId]);
  return null;
}
